import { Pipe, PipeTransform } from '@angular/core';
import { getFullName } from './user.functions';

@Pipe({
  name: 'fullName'
})
export class UserFullNamePipe implements PipeTransform {
    transform(inputValue?: any): string {
        return getFullName(inputValue);
    }
};